import React, { createContext, useRef } from "react";

export const ZoomContext = createContext();

const ZoomProvider = ({ children }) => {
  const mapRef = useRef(null);

  return (
    <ZoomContext.Provider value={{ mapRef }}>{children}</ZoomContext.Provider>
  );
};

export default ZoomProvider;
